import React from "react";
import { Text, View } from "@react-pdf/renderer";
import TextAreaLabel from "../../../exportacion_react_pdf/TextAreaLabel";
import CheckboxGroup from "../../../exportacion_react_pdf/CheckboxGroup";

const ExportPaso3 = ({ formData = {}, styles = {} }) => (
  <View style={styles.section}>
    <Text style={styles.title_1}>
      III. Producción (proceso productivo, calidad, buenas prácticas, manejo
      ambiental)
    </Text>
    <TextAreaLabel
      label={
        "¿Describa brevemente los productos y/o servicios más representativos del proyecto productivo? (para el caso de las tiendas por ejemplo indique víveres, productos de aseo, bebidas, productos de papelería o miscelánea)"
      }
      value={formData?.productos_representativos || ""}
    ></TextAreaLabel>

    <CheckboxGroup
      label="¿Se realizan controles o actividades para asegurar la calidad del producto, servicio, cosecha, cuidado de los animales o condiciones de almacenamiento de mercancía (para unidades comerciales)?"
      selectedValue={formData?.realizan_controles_actividades || ""}
      options={["Nunca", "Algunas veces", "Siempre"]}
    ></CheckboxGroup>

    <CheckboxGroup
      label="¿Se lleva registro y control de inventarios, número de animales o plantas o registro de recursos para proyectos de servicios (tales como duración promedio del servicio, insumos utilizados, cuantas personas realizan el servicio, etc.)?"
      selectedValue={formData?.registro_control_inventario || ""}
      options={["Nunca", "Algunas veces", "Siempre"]}
    ></CheckboxGroup>

    <CheckboxGroup
      label="¿Se cuentan con licencias, registros ante entidades de control, certificaciones o certificados para o en desarrollo de la actividad económica del proyecto productivo? Eje: Manejo de alimentos, registro ICA, registro INVIMA, etc."
      selectedValue={formData?.cuenta_licencias || ""}
    ></CheckboxGroup>

    {formData?.cuenta_licencias === "Sí" && (
      <TextAreaLabel
        label={
          "¿Indique cuales son las licencias, registros ante entidades de control, certificaciones o certificados que se tienen?"
        }
        value={formData?.respuesta_cuenta_licencia || ""}
      ></TextAreaLabel>
    )}

    <CheckboxGroup
      label="¿Se realiza una adecuada disposición de los residuos sólidos o líquidos generados por la realización de la actividad económica del proyecto?"
      selectedValue={formData?.adecuada_residuos_solidos || ""}
      options={["Nunca", "Algunas veces", "Siempre"]}
    ></CheckboxGroup>

    {(formData?.adecuada_residuos_solidos === "Algunas veces" ||
      formData?.adecuada_residuos_solidos === "Siempre") && (
      <TextAreaLabel
        label={
          "¿Describa brevemente las actividades de manejo y disposición de residuos sólidos o líquidos que realiza su proyecto productivo?"
        }
        value={formData?.respuesta_adecuada_residuos_solidos || ""}
      ></TextAreaLabel>
    )}

    <TextAreaLabel
      label={
        "¿Conjuntamente entre la persona en reincorporación y el asesor identifiquen una fortaleza representativa de la unidad en temas de producción (calidad, seguridad industrial y manejo ambiental)?"
      }
      value={formData?.fortaleza_representativa_tema_produccion || ""}
    ></TextAreaLabel>

    <TextAreaLabel
      label={
        "¿Conjuntamente entre la persona en reincorporación y el asesor identifiquen una debilidad representativa de la unidad en temas de producción (Calidad, Seguridad industrial y Manejo Ambiental)?"
      }
      value={formData?.debilidad_representativa_tema_produccion || ""}
    ></TextAreaLabel>
  </View>
);

export default ExportPaso3;
